import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

const DOC = gql`
  query AdminAgentKnowledgeBaseDownloadUrl(
    $input: AdminAgentKnowledgeBaseFileTargetInput!
  ) {
    adminAgentKnowledgeBaseDownloadUrl(input: $input)
  }
`

const TRANSFORMER = graphql.transformers.OUT.nonNull(
  graphql.transformers.OUT.select<
    graphql.schema.AdminAgentKnowledgeBaseDownloadUrlQuery,
    string,
    'adminAgentKnowledgeBaseDownloadUrl'
  >('adminAgentKnowledgeBaseDownloadUrl', transformers.PASS_THROUGH),
)

export const execute = graphql.createExecutor<
  graphql.schema.AdminAgentKnowledgeBaseDownloadUrlQuery,
  string,
  graphql.schema.AdminAgentKnowledgeBaseDownloadUrlQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
